const baseReset = {
  all: "unset",
  display: "revert",
  boxSizing: "border-box"
};
const boxSizing = {
  boxSizing: "border-box"
};
const interactiveReset = {
  all: "unset",
  display: "revert",
  boxSizing: "border-box",
  cursor: "pointer"
};
const listReset = {
  boxSizing: "border-box",
  listStyle: "none",
  margin: 0,
  padding: 0
};

export { baseReset, boxSizing, interactiveReset, listReset };
//# sourceMappingURL=reset.es.js.map
